<div *ngIf="text" class="banner  text-black  shadow-lg">
 <div *ngFor="let t of text" class="content">
       <div [innerHTML]="sanitizer.bypassSecurityTrustHtml(t.richText)"></div>
    </div>
</div>



